import { FC, ReactNode } from 'react';
import Modal from '../Modal';
import styles from './styles.module.css';
import Button from '../Button';
import classNames from 'classnames';

type Variant = 'withCancel' | 'error';
type Props = {
  title: ReactNode;
  description: ReactNode;
  onConfirm: () => void;
  confirmLabel?: string;
  onClose: () => void;
  cancelLabel?: string;
  variant?: Variant[];
};

/**
 * タイトル＋本文＋ボタンの構成のアラートダイアログモーダル。
 * 各画面で似たような構成のダイアログモーダルを独自に作っていたので共通化を見込んで作成。
 * TODO: 各画面への反映の展開
 */
export const AlertDialog: FC<Props> = ({
  title,
  description,
  onConfirm,
  confirmLabel = '確定',
  onClose,
  cancelLabel = 'キャンセル',
  variant = [],
}) => {
  const withCancel = variant.includes('withCancel');
  return (
    <Modal onRequestClose={onClose}>
      <div className={classNames(...variant.map((v) => styles[v]))}>
        <div className={styles.modalHead}>{title}</div>
        <div className={styles.modalContent}>
          <div className={styles.modalText}>{description}</div>
        </div>
        <div className={styles.buttons}>
          {withCancel && (
            <div className={styles.button}>
              <Button
                type="button"
                variants={['fit', 'cancel']}
                onClick={onClose}
              >
                {cancelLabel}
              </Button>
            </div>
          )}
          <div className={styles.button}>
            <Button type="button" variants={['fit']} onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
